import { render, staticRenderFns } from "./ResponsiveGoalApp.vue?vue&type=template&id=2483a417&scoped=true&"
import script from "./ResponsiveGoalApp.vue?vue&type=script&lang=js&"
export * from "./ResponsiveGoalApp.vue?vue&type=script&lang=js&"
import style0 from "./ResponsiveGoalApp.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./ResponsiveGoalApp.vue?vue&type=style&index=1&id=2483a417&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2483a417",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
import { VMain } from 'vuetify/lib/components/VMain';
installComponents(component, {VApp,VMain})
